import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function getCustomerReport(params) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/customers`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
export async function getFavReport(params) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/favorites`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data?.data)
		.catch((error) => error?.response?.data);
}
export async function addFavouriteReport(data) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/favorites`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
export async function removeFavouriteReport(key) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/favorites/${key}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}

export async function getProductsReport(params) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/products`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
export async function getOrgReceipientEmails() {
	const API_URL = `${APP_API_URL_V2}/reports/org-emails`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data?.data)
		.catch((error) => error?.response?.data);
}
export async function sendEmailReport(data) {
	const API_URL = `${APP_API_URL_V2}/reports/org-emails/send`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response?.data);
}

export async function exportExcelReport(type, params) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/${type}/export/excel`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}

export async function downloadPdfReport(type, params) {
	const API_URL = `${APP_API_URL_V2}/reports/sales/${type}/export/pdf`;

	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response?.data);
}

export async function scheduleHistory(params) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled/history`;

	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data?.data)
		.catch((error) => error?.response?.data);
}

export async function getScheduledReport(params) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data?.data)
		.catch((error) => error?.response?.data);
}

export async function getScheduled(id) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data?.data)
		.catch((error) => error?.response?.data);
}
export async function changeScheduleStatus(id, type) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled/${id}/${type}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.patch(
			API_URL,
			{},
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		)
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
export async function updateScheduledReport(id, data) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.patch(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
export async function scheduledReport(data) {
	const API_URL = `${APP_API_URL_V2}/reports/scheduled`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res?.data)
		.catch((error) => error?.response?.data);
}
